// Context/useTokenFromURL.js
import { useEffect } from "react";

function useTokenFromURL() {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const stepId = urlParams.get("stepId");
    const widgetId = urlParams.get("widgetId");

    if (stepId) localStorage.setItem("newStep", stepId);
    if (widgetId) localStorage.setItem("widgetId", widgetId);
  }, []);
}

export default useTokenFromURL;
